// NPM
/* Load npm scripts here */

// VENDOR
/* Load vendor modules here */

// BUNDLES
/* Load bundles here */
import defaultBundle from 'bundles/default.bundle';

// COMPONENTS
/* Load components here */
import { initResendActivation } from 'components/alert/alert';

// PAGE
/* load page specific scripts */
import { loginForm } from './partials/loginForm';

// WRITE YOUR CODE HERE
defaultBundle();

initResendActivation();
loginForm.init();
